"use client"
import { useEffect } from "react"
import useSWR from "swr"
import { api } from "@/lib/api-client"
import type { PhoneReplyReadiness } from "@/modules/messaging/contracts"
import type { ActorId } from "./model"

export function usePhoneReadiness(threadId: string | undefined, actor: ActorId, enabled: boolean, revision: string) {
  const remote = useSWR<PhoneReplyReadiness>(enabled && threadId ? [actor, `/api/communications/${threadId}/phone?view=readiness`] : null,
    ([, url]: [string, string]) => api(url), { revalidateOnFocus: true, dedupingInterval: 5000, refreshInterval: enabled ? 60000 : 0, refreshWhenHidden: false, shouldRetryOnError: false })
  const { mutate } = remote
  useEffect(() => { if (enabled) void mutate().catch(() => {}) }, [enabled, revision, mutate])
  useEffect(() => {
    if (!enabled || !remote.data?.canReply || remote.data.channel !== "whatsapp" || !remote.data.replyUntil) return
    const delay = Math.max(0, Date.parse(remote.data.replyUntil) - Date.parse(remote.data.serverTime))
    const timer = setTimeout(() => void mutate().catch(() => {}), Math.min(delay + 100, 86400100))
    return () => clearTimeout(timer)
  }, [enabled, remote.data, mutate])
  return remote
}
